import { ButtonProps } from "./Button.types";
import "./Button.styles.scss";
import { useState } from "react";

export const Button: React.FC<ButtonProps> = ({
  label,
  backgroundColor,
  onClick,
  disabled = false,
  type = "button",
  loading,
  className,
}) => {
  const [isLoading, toggleLoading] = useState<boolean>(false);
  /**
   * Handler for button click with onClick promise support
   */
  const handleClick = (): void => {
    // skip if no onClick handler is provided
    if (!onClick || disabled) return;

    // call the onClick handler
    const onClickResult = onClick();

    // skip if onClick does not return a promise or if loading is already set
    if (!(onClickResult instanceof Promise) || loading !== undefined) return;

    // toggle loading state
    toggleLoading(true);

    // reset loading state when promise finished
    onClickResult.finally(() => toggleLoading(false));
  };

  return (
    <div className={`button-component__wrapper`} onClick={handleClick}>
      <button
        data-testid="button-component-button"
        type={type}
        disabled={disabled || loading || isLoading}
        className={`button-component__button ${
          disabled ? "disabled" : ""
        } ${className}`}
        style={{ backgroundColor }}
      >
        {(isLoading || loading) && !disabled ? (
          <div className="loader" />
        ) : (
          label
        )}
      </button>
    </div>
  );
};
